// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2bUgE","col":"styles_col__2wyoY"};